import React from 'react';
import { Button } from 'carbon-components-react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useWindowSize } from '../../customHooks/useWindowSize';
const useStyles = makeStyles(theme => ({
  mainContainer: {
    width: '100%'
  }
}));

const useButtonsStyles = makeStyles(theme => ({
  buttonAsLink: {
    fontFamily: 'Roboto-Light',
    fontSize: '14px',
    letterSpacing: 0,
    textAlign: 'left',
    margin: 0,
    padding: 0,
    marginLeft: '0px !important',
    background: 'transparent',
    border: 'none !important',
    outlined: 'none !important',
    '&:hover': {
      background: 'transparent !important'
    },
    '&:focus': {
      outlineColor: 'transparent !important'
    }
  }
}));

const BottomLinks = props => {
  const { textColor, origin } = props;
  const classes = useButtonsStyles();
  const gridClasses = useStyles();
  const size = useWindowSize();

  return (
    <Grid
      container
      direction={
        origin === 'searcher'
          ? size.width > 940
            ? 'row'
            : 'column'
          : size.width > 785
            ? 'row'
            : 'column'
      }
      justify='flex-start'
      alignContent='flex-start'
      className={gridClasses.mainContainer}
    >
      <Grid item>
        <Button
          className={classes.buttonAsLink}
          onClick={() => {}}
          outlined='false'
          kind='ghost'
          size='small'
          type='button'
          style={{
            color: textColor,
            fontSize: size.width <= 600 ? 12 : 14,
            marginRight: size.width <= 600 ? 0 : 35,
            paddingLeft: origin === 'searcher' ? 16 : size.width <= 600 ? 0 : 16
          }}
        >
          Terms & Conditions
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.buttonAsLink}
          outlined='false'
          kind='ghost'
          size='small'
          type='button'
          style={{
            color: textColor,
            fontSize: size.width <= 600 ? 12 : 14,
            marginRight: size.width <= 600 ? 0 : 35,
            paddingLeft: origin === 'searcher' ? 16 : size.width <= 600 ? 0 : 16
          }}
          onClick={() => {}}
        >
          Contact Us
        </Button>
      </Grid>
      <Grid item>
        <Button
          className={classes.buttonAsLink}
          outlined='false'
          kind='ghost'
          size='small'
          type='button'
          style={{
            color: textColor,
            fontSize: size.width <= 600 ? 12 : 14,
            marginRight: size.width <= 600 ? 0 : 35,
            paddingLeft: origin === 'searcher' ? 16 : size.width <= 600 ? 0 : 16
          }}
          onClick={() => {}}
        >
          Read more about the License
        </Button>
      </Grid>
    </Grid>
  );
};

export default BottomLinks;
